<div class="dialog-container">
    <div class="dialog-header">
        <h2 mat-dialog-title>Edit Loan Installment</h2>
        <button mat-icon-button (click)="onCancel()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content>
        <div class="loan-header-info">
            <div class="info-row">
                <mat-icon>person</mat-icon>
                <div class="info-content">
                    <span class="label">Employee:</span>
                    <span class="value">{{ loanHeaderData.employeeName }}</span>
                </div>
            </div>
            <div class="info-row">
                <mat-icon>account_balance</mat-icon>
                <div class="info-content">
                    <span class="label">Total Loan:</span>
                    <span class="value">{{ formatCurrency(loanHeaderData.loanAmount) }}</span>
                </div>
            </div>
        </div>

        <mat-divider></mat-divider>

        <form [formGroup]="loanLineForm" class="loan-line-form">
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Due Date</mat-label>
                    <input matInput type="date" formControlName="dueDate">
                    <mat-error *ngIf="loanLineForm.get('dueDate')?.hasError('required')">
                        Due date is required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Amount to Pay</mat-label>
                    <input matInput type="number" formControlName="toPay" placeholder="Enter amount" readonly>
                    <span matPrefix>₱&nbsp;</span>
                    <mat-icon matSuffix>payments</mat-icon>
                    <mat-error *ngIf="loanLineForm.get('toPay')?.hasError('required')">
                        Amount is required
                    </mat-error>
                    <mat-error *ngIf="loanLineForm.get('toPay')?.hasError('min')">
                        Amount must be greater than or equal to 0
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Payment Status</mat-label>
                    <input matInput formControlName="status" readonly>
                    <mat-icon matSuffix
                        [ngClass]="{'paid-icon': loanLineData.isPaid, 'pending-icon': !loanLineData.isPaid}">
                        {{ loanLineData.isPaid ? 'check_circle' : 'pending' }}
                    </mat-icon>
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()" [disabled]="isLoading">
            Cancel
        </button>
        <button mat-raised-button color="primary" (click)="onSave()"
            [disabled]="isLoading || loanLineForm.invalid || loanLineData.isPaid">
            <mat-icon *ngIf="!isLoading">save</mat-icon>
            <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
            {{ isLoading ? 'Saving...' : 'Save Changes' }}
        </button>
    </mat-dialog-actions>
</div>